/* Early Black Friday: native Shopify discount remains the source of truth. */
(() => {
  'use strict';
  const el = document.getElementById('sbw-bf-config');
  if (!el) return;
  const cfg = JSON.parse(el.textContent), root = window.Shopify?.routes?.root || '/';
  const eligible = new Set(cfg.eligible), own = i => i.properties?._sbw_early_bf_gift === '1';
  const amount = c => c.items.reduce((n,i) => n + (eligible.has(i.product_id) ? i.final_line_price : 0),0);
  const free = c => c.items.some(i => i.product_id === cfg.mirrorId && i.final_price === 0);
  let chain = Promise.resolve(), timer, declined = false, lastOwn = false, checkoutBusy = false;
  const money = n => 'A$' + (Math.max(0,n)/100).toFixed(2);
  async function api(path, data) {
    const r = await fetch(root + path,{credentials:'same-origin',cache:'no-store',...(data ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {})});
    const v = await r.json(); if (!r.ok) throw new Error(v.description || 'Unable to update your gift. Please try again.');return v;
  }
  function paint(c,error='') {
    const n=amount(c), aud=c.currency==='AUD', unlocked=free(c);
    const cartLink=document.getElementById('cart-notification-button');if(cartLink)cartLink.textContent='View cart ('+c.item_count+')';
    document.querySelectorAll('[data-bf-offer="cart"]').forEach(box=>{
      const message = !aud ? 'Spend A$99 on eligible products to unlock your free mirror. The threshold is converted at checkout.' : unlocked ? 'Your FREE LED Travel Makeup Mirror worth A$39.99 is in your bag. Enjoy your extra glow ✨' : n<9900 ? 'A little extra glow is within reach ✨ Add '+money(9900-n)+' more in eligible products to unlock your FREE LED Makeup Mirror worth A$39.99.' : 'Your silk essentials qualify! Add your FREE LED Travel Makeup Mirror below.';
      box.querySelector('[data-bf-message]').textContent=message;
      const p=box.querySelector('progress');p.value=Math.min(99,n/100);p.hidden=!aud;
      box.querySelector('[data-bf-claim]').hidden=!(aud&&n>=9900&&!unlocked);
    });
    document.querySelectorAll('[data-bf-error]').forEach(e=>{e.textContent=error;e.hidden=!error;});
  }
  async function refresh() {
    const targets={'cart-drawer':['cart-drawer-items','.cart-drawer__footer'],'cart-icon-bubble':['#cart-icon-bubble']};
    for(const id of ['main-cart-items','main-cart-footer']){const e=document.getElementById(id);if(e)targets[e.dataset.id||id]=['#'+id+' .js-contents'];}
    const sections=await api('cart?sections='+Object.keys(targets).join(','));
    for(const [key,selectors] of Object.entries(targets)) {
      if(!sections[key])continue;
      const doc=new DOMParser().parseFromString(sections[key],'text/html');
      for(const selector of selectors){const a=document.querySelector(selector),b=doc.querySelector(selector);if(a&&b)a.innerHTML=b.innerHTML;else if(a&&key==='cart-icon-bubble')a.innerHTML=sections[key];}
    }
  }
  async function reconcile(force=false) {
    let c=await api('cart.js'),changed=false,error='';
    const hasOwn=c.items.some(own);
    if(lastOwn&&!hasOwn&&amount(c)>=9900)declined=true;
    if(force)declined=false;
    // Remove only our automatically added gifts; never remove a mirror bought by the customer.
    for(const i of c.items.filter(own)) {
      if(c.currency!=='AUD'||amount(c)<9900||i.quantity!==1) {
        await api('cart/change.js',{id:i.key,quantity:0});changed=true;
      }
    }
    if(changed)c=await api('cart.js');
    if(c.currency==='AUD'&&amount(c)>=9900&&!free(c)&&!c.items.some(i=>i.product_id===cfg.mirrorId)&&!declined&&cfg.variantId) {
      try {await api('cart/add.js',{items:[{id:cfg.variantId,quantity:1,properties:{_sbw_early_bf_gift:'1'}}]});changed=true;}
      catch(e){declined=true;error='The gift could not be added. Please try “Add my free gift” again, or contact us before placing your order.';}
      c=await api('cart.js');
    }
    // Fail safe: an automatic gift must never be charged if another discount wins.
    for(const i of c.items.filter(i=>own(i)&&i.final_price>0)) {
      await api('cart/change.js',{id:i.key,quantity:0});changed=true;declined=true;
      error='Your gift could not be applied. This offer cannot be combined with other discounts. Remove any other discount and select “Add my free gift”, or contact us before checkout.';
    }
    if(changed){c=await api('cart.js');await refresh();}
    lastOwn=c.items.some(own);if(amount(c)<9900)declined=false;
    paint(c,error);return c;
  }
  function enqueue(force=false){const job=chain.catch(()=>{}).then(()=>reconcile(force));chain=job;job.catch(()=>{document.querySelectorAll('[data-bf-error]').forEach(e=>{e.hidden=false;e.textContent='Please refresh your cart to confirm your free gift before checkout.';});});return job;}
  function schedule(){clearTimeout(timer);timer=setTimeout(()=>enqueue(),400);}
  if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.cartUpdate,schedule);
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-bf-claim]')){e.preventDefault();enqueue(true);return;}
    if(!e.target.closest('[name="checkout"]'))return;
    e.preventDefault();e.stopImmediatePropagation();if(checkoutBusy)return;checkoutBusy=true;
    clearTimeout(timer);
    enqueue().then(()=>{window.location.assign(root+'checkout');}).catch(()=>{checkoutBusy=false;});
  },true);
  // Repaint after Dawn's independent section replacement, without another cart mutation.
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  enqueue();
})();
